/**
 * platform.ts — Desktop Platform Detection (Renderer Side)
 *
 * Определяет, запущено ли приложение как Electron desktop.
 * Аналог mobile-app/src/capacitor/platform.ts для desktop.
 *
 * Используется в React-компонентах для условного рендеринга.
 */

declare global {
  interface Window {
    smeet?: import('./types').SMeetDesktopAPI;
  }
}

/** true если запущено в Electron desktop-приложении */
export const isDesktop = typeof window !== 'undefined' && !!window.smeet?.platform?.isDesktop;

/** true если это macOS */
export const isMac = isDesktop && (window.smeet?.platform?.isMac ?? false);

/** true если это Windows */
export const isWindows = isDesktop && (window.smeet?.platform?.isWindows ?? false);

/** Версия desktop-приложения */
export const desktopVersion = isDesktop ? (window.smeet?.platform?.version ?? '1.0.0') : null;

/** Удобный объект для условного рендеринга */
export const platform = {
  isDesktop,
  isMac,
  isWindows,
  isNative: isDesktop,
  isMobile: false,
  isIOS: false,
  isAndroid: false,
} as const;
